export default {
  pt: {
    pageTitle: "Sua Marca",
    description: "Qual a marca da sua bike?",
    searchLabel: "Pesquise o modelo ou tipo",
  },

  en: {
    pageTitle: "Your Brand",
    description: "What is your bike brand?",
    searchLabel: "Search for model or type",
  },
}; 